$(function() {
  var awarenessBar = $('.ti-awareness-bar');

  $('.awareness-bar-close').on('click', function() {
    awarenessBar.slideUp();
    // Server will look for this cookie; if set, it won't instantiate an awareness bar
    Cookies.set('awareness-bar-closed', true, {expires: 1});
  });
});
